import React, { useState, useEffect, useContext } from "react";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

// API
import ContentService from "../../../services/content.service";

// Context
import { StateContext } from "../../../common/context/StateContext";

// Utils
import { PageGutter } from "../../../common/utils/constants";

// Components
import Loader from "../../../common/components/Loader";
import Typography from "../../../common/components/Typography";
import SwiperContainer from "../../../common/components/SwiperContainer";

// Mui
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

const Container = styled.section`
    padding: ${PageGutter};
    position: relative;
    background-color: white;
`;

const InstitutionBlock = styled(Stack)`
    padding: 40px 0;

    .logo {
        background-image: url(${(props) => props.logo});
        background-color: white;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: 200px;
        height: 200px;
        border-radius: 50%;
    }
`;

const Insititutions = ({}) => {
    const { setNotificationMessage } = useContext(StateContext);

    const [isLoading, setIsLoading] = useState(true);
    const [institutions, setInstitutions] = useState([]);

    useEffect(() => {
        getInstitutions();
    }, []);

    const getInstitutions = async () => {
        const api = await ContentService.getInstitutions();

        if (api.status) {
            setIsLoading(false);
            setInstitutions(api.data);
        } else {
            setIsLoading(false);
            setNotificationMessage({
                message: "Could not fetch institutions.",
                type: "error",
            });
        }
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <Container>
            <Typography variant="h4" mb>
                Trusted by These Great Institutions
            </Typography>
            <SwiperContainer
                autoplay={true}
                breakpoints={{
                    600: {
                        slidesPerView: 1,
                    },
                    900: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    1536: {
                        slidesPerView: 5,
                    },
                }}
            >
                {institutions &&
                    institutions.map((institution, index) => (
                        <SwiperSlide key={index}>
                            <InstitutionBlock
                                logo={institution.logo}
                                alignItems="center"
                            >
                                <div className="logo"></div>
                                <Box mt={2}>
                                    <Typography variant="h6">
                                        {institution.name}
                                    </Typography>
                                </Box>
                                <Typography variant="paragraph">
                                    {institution.country}
                                </Typography>
                            </InstitutionBlock>
                        </SwiperSlide>
                    ))}
            </SwiperContainer>
        </Container>
    );
};

export default Insititutions;
